export default __webpack_public_path__ + "static/facts-and-figures-icon-4-18224847b8c22ba1331a5d972180b134.svg";